import type { TeamMember } from "../_logic/team-members";

/**
 * Renders a team member's role, name, and hometown — shared by the mobile and desktop cards.
 * @param props.member - The member whose details to display.
 * @returns The card's textual content.
 */
export const TeamCardContent = ({ member }: { member: TeamMember }) => (
  <>
    <div className="flex flex-col gap-1.5">
      <p className="text-sm font-medium text-landing-secondary tracking-[-0.03em] leading-4">{member.role}</p>
      <h3 className="text-2xl font-medium text-black tracking-[-0.03em] leading-7">{member.name}</h3>
    </div>
    {member.location && (
      <div className="flex items-center gap-1.5">
        <span className="text-sm leading-none" aria-hidden>
          {member.flag}
        </span>
        <span className="text-sm font-medium text-landing-secondary tracking-[-0.03em] leading-5">
          {member.location}
        </span>
      </div>
    )}
  </>
);
